import { IncentiveCategory } from '@varo/graphql-schema-types';
import { IncentiveScreenNames } from 'features/incentive/helpers/incentiveAnalytics';
import { useIncentiveScreenViewed } from 'features/incentive/hooks/useIncentiveAnalytics';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from 'shared/constants/platform';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import EmptyStateScreen from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';
import theme from 'shared/styles/theme';
import { downloadVaroApp } from 'shared/utils/downloadVaroApp';

interface IncentiveUnsupportedContentScreenProps {
  incentiveType: IncentiveCategory;
}

function IncentiveUnsupportedContentScreen({
  incentiveType,
}: IncentiveUnsupportedContentScreenProps) {
  const { t: translatedText } = useTranslation('incentive', {
    keyPrefix: 'unsupportedContent',
  });
  const { top } = useSafeAreaInsets();

  useIncentiveScreenViewed({
    screenName: IncentiveScreenNames.UNSUPPORTED_CONTENT,
    incentiveType,
  });

  const handleUpdateApp = () => {
    void downloadVaroApp();
  };

  return (
    <View style={[styles.container, { paddingTop: top }]}>
      <EmptyStateScreen
        illustrationKey="PLACEHOLDER_A"
        headlineText={translatedText('headline')}
        bodyText={translatedText('body')}
        actionButtonText={translatedText(isWeb ? 'goBack' : 'updateApp')}
        actionOnPress={isWeb ? navigateBack : handleUpdateApp}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default IncentiveUnsupportedContentScreen;
